module.exports = __webpack_public_path__ + "static/media/asv_bloc4-min.13f7f32e.png";